<!-- <div class="ua-debug-bar">{{ userAgent }}</div> -->
<router-outlet></router-outlet>
